// extracted by mini-css-extract-plugin
export default {"text":"RecaptchaBadge__text","reducedTopMargin":"RecaptchaBadge__reducedTopMargin"};